// Says out loud that a chart's window opens before the device existed (#184).
//
// The chart range floor is 2026-01-01, deliberately sixteen days before the
// oldest reading in the system. That is the right floor — a round date nobody
// has to look up, and one that cannot exclude a reading — but it has a
// consequence: four of the ten devices in the deployment came online months
// later, so their full-range chart opens on a long blank stretch.
//
// A blank stretch is exactly what an outage looks like. #155 exists because this
// product refuses to let silence read as health; a device that did not yet exist
// rendering as a device that went quiet is the same error inverted. #167 made
// ingestion gaps visible for the same reason, and this is the other half of it:
// a gap that is not a gap has to be labelled as well.
//
// One component, four callers, like AggregationNotice.

import { preDataMessage } from "../chartRange";

export default function PreDataNotice({ notice, t = (k) => k }) {
  const message = preDataMessage(notice, t);
  if (!message) return null;

  // The "nothing to plot" case gets the stronger treatment: the chart is empty,
  // and an unexplained empty chart is the thing most likely to be read as a
  // fault in the system rather than a fact about the device.
  const style = notice.key === "preDataNone" ? styles.noteNone : styles.note;
  return <p style={style}>{message}</p>;
}

const styles = {
  note: {
    margin: "0 0 10px",
    fontSize: 11,
    color: "#6b7280",
    lineHeight: 1.5,
  },
  noteNone: {
    margin: "0 0 10px",
    fontSize: 12,
    color: "#1e40af",
    background: "#eff6ff",
    border: "1px solid #bfdbfe",
    borderRadius: 4,
    padding: "6px 10px",
    lineHeight: 1.5,
  },
};
